import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store';
import router from './router';
import i18n from './plugins/i18n.js';
import axios from 'axios';
import linkify from './directives/linkify';

Vue.directive('linkify', linkify);

import ValidationPlugin from "@/plugins/validation.plugin";
import GoogleAnalyticsEventsHelper from '@/plugins/google-analytics-events-helper';

Vue.config.productionTip = false

Vue.use(ValidationPlugin);
Vue.use(GoogleAnalyticsEventsHelper);

/**
 * Initialize Kirami Chat widget
 * @param {Object} config - Configuration object
 * @param {string} config.containerId - ID of the DOM element to mount the chat widget
 * @param {string} config.apiKey - API key for authentication
 * @param {string} [config.language] - Language code (e.g., 'fi', 'en', 'se')
 * @param {string} [config.searchQuery] - Initial search query to send
 * @param {string} [config.baseUrl] - Base URL for API requests
 * @returns {Object} Instance object with destroy method
 */
function KiramiChat(config = {}) {
  const {
    containerId = 'app',
    apiKey,
    language,
    searchQuery,
    baseUrl,
    ...otherOptions
  } = config;

  // Set base URL if provided
  if (baseUrl) {
    axios.defaults.baseURL = baseUrl;
  } else if (process.env.VUE_APP_BASE_URL) {
    axios.defaults.baseURL = process.env.VUE_APP_BASE_URL.trim();
  }

  // Note: API key (session ID) is set in EmbedChatView.vue mounted hook
  // If apiKey is provided in config, it will be used there
  // Otherwise, the auto-generated session ID from store will be used

  // Find or create container
  let container = document.getElementById(containerId);
  if (!container) {
    console.error(`KiramiChat: Container with id "${containerId}" not found`);
    return null;
  }

  // Create mount point inside container
  const mountPoint = document.createElement('div');
  mountPoint.id = 'app';
  container.appendChild(mountPoint);

  // Store widget config for access by components
  const widgetConfig = {
    language,
    searchQuery,
    apiKey,
    baseUrl,
    ...otherOptions
  };

  // Initialize Vue instance
  const instance = new Vue({
    vuetify,
    store,
    router,
    i18n,
    data() {
      return {
        widgetConfig
      };
    },
    render: h => h(App)
  }).$mount(mountPoint);

  return {
    instance,
    destroy: () => {
      instance.$destroy();
      if (mountPoint && mountPoint.parentNode) {
        mountPoint.parentNode.removeChild(mountPoint);
      }
    }
  };
}

// Export for UMD build
export default KiramiChat;

// Auto-initialize if window.KiramiChatConfig exists
if (typeof window !== 'undefined' && window.KiramiChatConfig) {
  KiramiChat(window.KiramiChatConfig);
}
